export const pdfStyled = (theme, hasTransparentBackground) => ({
  backgroundColor: hasTransparentBackground
    ? 'transparent'
    : theme.palette.colors.primaryBackground,
  height: 'inherit',
});
